import { PLAYBACK_FRAMES_PER_SECOND } from '../../../constants';

// This magical number (by trial and error) allows us to maintain a 30+ fps while extracting frames
export const MAX_FRAME_COUNT = 20;

const EPISODE_TIMELINE_ZOOMED_IN_WIDTH_IN_SECONDS = 10;
export const EPISODE_TIMELINE_ZOOMED_IN_WIDTH_IN_FRAMES =
  EPISODE_TIMELINE_ZOOMED_IN_WIDTH_IN_SECONDS * PLAYBACK_FRAMES_PER_SECOND;
export const EPISODE_TIMELINE_ZOOMED_IN_FRAMES_PER_HALF =
  EPISODE_TIMELINE_ZOOMED_IN_WIDTH_IN_FRAMES / 2;
